<pw-progress-bar *ngIf="totalQuantity >0"></pw-progress-bar>
<div class="payment-container">
    <h3>{{"shoppingCart.typeOfPayment" | translate }}</h3>
    <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="paymentOption">
        <div class="simple-container">
            <mat-radio-button (click)="clickOnSimplePay()" class="example-radio-button" value="SIMPLE">
                <h4>Simple Pay</h4>
            </mat-radio-button>
            <div class="simple-image">
                <img src="../../assets/images/simplepay.png" />
            </div>
        </div>
        <mat-radio-button *ngIf="deliveryOption === 'STORE_PICKUP'&&!hasPreorder" (click)="clickOnPayAtSite()" class="example-radio-button" value="CASH">
            <h4>Fizetés a helyszínen</h4>
        </mat-radio-button>
    </mat-radio-group>
    <div class="button-main-container">
        <div class="button-container">
            <button routerLink="/delivery">{{"shoppingCart.backToDelivery" | translate }}</button>
            <button (click)="goToCartSummary()">{{"shoppingCart.goToSummary" | translate }}</button>
        </div>
    </div>
</div>
